import React from 'react';
import { EmptyTab } from '../../EmptyTab';
import classNames from 'classnames';

interface PropTypes {
  type: string;
}

function getSelectedEmptyTab(props: PropTypes) {
  switch (props.type) {
    case 'all':
      return (
        <EmptyTab
          title={`No Highlights available yet`}
          text={
            'We are processing the interview highlights. Please check back later.'
          }
        />
      );
    case 'scorecard_attribute':
      return (
        <EmptyTab
          title={`No Attributes available yet`}
          text={
            'We are processing the interview attributes. Please check back later.'
          }
        />
      );
    case 'note':
      return (
        <EmptyTab
          title={`No Notes available yet`}
          text={
            'Use the input below to add a note, or enable Screenloop’s Sidekick to add notes and reactions.'
          }
        />
      );
    case 'reaction':
      return (
        <EmptyTab
          title={`No Reactions available`}
          text={
            'Start using the Screenloop Sidekick to add notes and reactions.'
          }
        />
      );
    case 'automatic_question':
      return (
        <EmptyTab
          title={`No Questions available yet`}
          text={
            'We are processing the interview questions. Please check back later.'
          }
        />
      );
  }
}

export function EmptyState(props: PropTypes) {
  return (
    <div className={classNames('d-flex', 'flex-column', 'gap-3')}>
      {getSelectedEmptyTab(props)}
    </div>
  );
}
